/* @ngInject */
export default class IncomeStatementCtrl {
	constructor(
		$sce,
		$scope,
		$state,
		Utility,
		$timeout,
		$rootScope,
		BuildingsService,
		FinancialsService,
		LocalStorageService,
		IncomeStatementService,
		AuthorizationService
	) {
		this.$sce = $sce;
		this.$scope = $scope;
		this.$state = $state;
		this.Utility = Utility;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.BuildingsService = BuildingsService;
		this.FinancialsService = FinancialsService;
		this.LocalStorageService = LocalStorageService;
		this.IncomeStatementService = IncomeStatementService;
        this.AuthorizationService = AuthorizationService;

		this.init();
		this.activate();
	}

	init() {
		this.financialsServiceData = this.FinancialsService;
		this._switchIsBusyLoading(true);
		this.selectedBuildingRef = '';
		this.selectedBuildingName = '';
		this.statusInformation = null;
		this.today = this.Utility.getFormatedDate(new Date());
		this.reportModelHeader = '';

		this.isFilterActive = true;
		this.filterYear = undefined;
		this.isMonthlyView = true;
		this.filterMonth = undefined;
		this.selectedDate = this.Utility.getFormatedDate(new Date());
		this.selectedDateYear = this.Utility.getFormatedDate(new Date());

		this.stickableStyles = `
				top: -0.5em;
				left: 4.93em;
				width: 91.74%;
				z-index: 10;
				position: fixed;
				background-color: #e8e8e8;
			`;

		this.$scope.$on('selected-building-changed', async (event, newValue) => {
			await this.onSelectedBuildingChanged(this, newValue);
		});
	}

	async activate() {
		this.selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();

		var buildingName = '';
		const userProfile = this.LocalStorageService.retrieve('userProfile');

		if (userProfile) {
			if (!this.selectedBuildingRef) {
                this.selectedBuildingRef = userProfile.BuildingProfiles[0].SchemeReference;
            }
			const selectedBuilding = userProfile.BuildingProfiles.find((building) => {
				return building.SchemeReference.toUpperCase().trim() === this.selectedBuildingRef.toUpperCase().trim();
			});

			if (selectedBuilding) {
				buildingName = selectedBuilding.SchemeName;
			}
		}

		await this.getFinancialYears(true);
		this.selectedBuildingName = buildingName;
	}

	openFinancials(page) {
        this.saveSelectedDate();
        this.$rootScope.$broadcast('navigate-changed', page, { date: this.filterMonth });
    }

	saveSelectedDate() {
        const selectedYear = moment(this.filterYear).toDate();
        const selectedMonth = moment(this.filterMonth).add(3, 'h').toDate();
        this.LocalStorageService.save('selectedReportYear', selectedYear);
        this.LocalStorageService.save('selectedReportMonth', selectedMonth);
    }

    async gotoOldFinancials() {
        const date = moment(this.filterMonth).format('MMM YYYY');
        let nav = `Monthly Financial Statements>${date}`;
        nav = encodeURI(nav);
        this.$state.go('documents', { nav });
    }

	isDesktop() {
		this.LocalStorageService.save('mediaDevice', 'mobile');
		const mdvice = this.LocalStorageService.retrieve('mediaDevice');
		if (mdvice == 'mobile') {
			return true;
		}

		return false;
	}

	async filterByCurrentMonth() {
		this.isFilterActive = true;
		this.selectedDate = this.Utility.getFormatedDate(new Date());
		await this.getIncomeStatement();
	}

	async filterByMonth() {
		this.$timeout(async () => {
			if (this.filterMonth) {
				this.selectedDate = this.Utility.getFormatedDate(this.filterMonth);
				await this.getIncomeStatement();
			}
		});
	}
	async filterByYear() {
		this.filterMonth = '';
		this.selectedDateYear = this.Utility.getFormatedDate(this.filterYear);
		if (this.isMonthlyView) {
			await this.getFinancialMonths(this.selectedDateYear);
		} else {
			this.selectedDate = this.Utility.getFormatedDate(this.filterYear);
			await this.getIncomeStatement();
		}
	}

	async getReport() {
		this.reportModelHeader =
			this.selectedBuildingName + ' - Income Statement - ' + moment(this.selectedDate).format('MMM YYYY');
		await this.financialsServiceData.getReport(
			this.selectedBuildingRef,
			this.selectedDate || moment(this.selectedDateYear),
			1,
			this.reportModelHeader
		);
	}

	async onSelectedBuildingChanged(event, schemeRef) {
		if (schemeRef && schemeRef['length'] > 2) this.selectedBuildingRef = schemeRef;
		else this.selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();

		if (this.selectedBuildingRef && this.selectedBuildingRef.length > 2) {
			await this.activate();
		}
	}

	async getFinancialYears(isInit) {
		this._switchIsBusyLoading(true);

		try {
			await this.financialsServiceData.getFinancialYears(this.selectedBuildingRef, this.today);
			if (isInit) {
				await this.getSelectedDate(true);
			} else {
				this.filterYear = this.financialsServiceData.financialYears[
					this.financialsServiceData.financialYears.length - 1
				].WhenTo;
				this.selectedDateYear = this.Utility.getFormatedDate(this.filterYear);
				await this.getIncomeStatement();
			}
		} catch (err) {
			console.error(`Error loading Financial Years`, err);
		} finally {
			this._switchIsBusyLoading(false);
		}
	}
		
	async getFinancialMonths(date, isInit) {
		this._switchIsBusyLoading(true);
		try {
			await this.financialsServiceData.getFinancialMonths(this.selectedBuildingRef, date || new Date());
			let selectedMonthIndex = -1;

			const selectedDateMonth = await this.financialsServiceData.getSelectedMonth();

			if (selectedDateMonth) {
				if (this.financialsServiceData.financialMonths && this.financialsServiceData.financialMonths.length > 0) {
					const foundMonth = this.financialsServiceData.financialMonths.find((month, index) => {
						const momentMonth = moment(month.WhenFrom);
						if (momentMonth.isSame(selectedDateMonth, 'month')) {
							selectedMonthIndex = index;
							return true;
						}
					});

					if (selectedMonthIndex > -1 && foundMonth) {
						this.filterMonth = this.financialsServiceData.financialMonths[selectedMonthIndex].WhenFrom;
						this._filterOutFutureMonths();
					}
				}
			} else if (date && isInit) {
				this.financialsServiceData.financialMonths.filter(async (month, i) => {
					const monthDateStr = month.WhenFrom.substr(0, 10);
					const monthDate = moment(new Date(monthDateStr), 'YYYY-DD-MM');
					const selectedMonth = await this.financialsServiceData.getSelectedMonth();

					if (monthDate.isSame(selectedMonth, 'month')) {
						selectedMonthIndex = i;
						return true;
					}
				});

				if (selectedMonthIndex === -1) {
					this.filterMonth = '';
				} else {
					this.filterMonth = this.financialsServiceData.financialMonths[selectedMonthIndex].WhenFrom;
				}
			} else if (isInit) {
				this.filterMonth = this.financialsServiceData.financialMonths[
					this.financialsServiceData.financialMonths.length - 1
				].WhenFrom;
			}
			if (this.filterMonth) {
				this.selectedDate = this.filterMonth;
				await this.getIncomeStatement();
			}
		} catch (err) {
			console.error(`Error while loading financial months\n${err}`);
		} finally {
			this._switchIsBusyLoading(false);
		}
	}

	_filterOutFutureMonths() {
		const today = new Date();
		const formatedDate = moment(today).format('YYYY MMMM');
		const currentYear = formatedDate.split(' ')[0];
		const currentMonth = formatedDate.split(' ')[1];

		let foundIndex = -1;
		const found = this.financialsServiceData.financialMonths.find((month, index) => {
			const fields = month.FriendlyNameMonth.split(' ');
			const yearStr = fields[1];
			const monthStr = fields[0];
			const found = currentYear === yearStr && currentMonth === monthStr;

			if (found) {
				foundIndex = index;
			}
			return found;
		});

		if (found && foundIndex > -1) {
			const filteredMonths = this.financialsServiceData.financialMonths.filter(
				(month, index) => index < foundIndex + 1
			);

			if (filteredMonths && filteredMonths.length < this.financialsServiceData.financialMonths.length) {
				this.financialsServiceData.financialMonths = filteredMonths;
			}
		}
	}

	async getIncomeStatement() {
		this._switchIsBusyLoading(true);
		try {
			await this.IncomeStatementService.getIncomeStatement(
				this.selectedBuildingRef,
				this.Utility.getFormatedDate(this.filterMonth)
			);
			await this.getFinancialState();
		} catch (err) {
			console.error(`Error while loading Income Statement`, err);
		} finally {
			this._switchIsBusyLoading(false);
		}
	}

	async getSelectedDate(isInit) {
		const selectedDateYear = this.financialsServiceData.getSelectedYear();
		if (isInit) {
			let index = 0;
			for (let i = 0; i < this.financialsServiceData.financialYears.length; i++) {
				const yearRaw = this.financialsServiceData.financialYears[i];

				if (selectedDateYear.isBetween(yearRaw.WhenFrom, yearRaw.WhenTo)) {
					index = i;
					this.filterYear = this.financialsServiceData.financialYears[i].WhenTo;
					this.selectedDateYear = this.Utility.getFormatedDate(this.filterYear);

					break;
				}
			}

			const date = selectedDateYear ? selectedDateYear : new Date();
			await this.getFinancialMonths(date, true);
		}
	}

	async getFinancialState() {
		const type = 1;
		const schemeRef = this.selectedBuildingRef;
		const momentDate = moment(this.selectedDate, 'YYYY-MM-DD');
		const formattedDate = momentDate.format('YYYY-MM-DD');
		const date = `${formattedDate.substr(0, 8)}01`;

		this._switchIsBusyLoading(true);
		try {
			const results = await this.FinancialsService.getFinancialState(schemeRef, date, type);

			const { status, message } = results;
			this.statusInformation = message;
		} catch (error) {
			this.NotificationService.error('Error loading income statement status');
		} finally {
			this._switchIsBusyLoading(false);
		}
	}

	allowAction(actionName) {
        return this.AuthorizationService.isAuthorized(actionName);
    }

	_switchIsBusyLoading(flag) {
		this.$timeout(() => {
			this.isLoading = flag;
		});
	}
}
